<template>
    <div>
        <mobile-map v-show="this.$route.name === 'ngMap' || this.$route.name === 'WebMap'" />
        <router-view></router-view>
    </div>
</template>

<script>
    import mobileMap from '../../components/geo/maps/Web.vue';
    export default { components: { 'mobile-map': mobileMap } };
</script>
